import {
  Category,
  Department,
  LayoutNodeFilterType,
} from "@towersystems/roam-common/lib/generated-types";
import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { toggleListItem } from "@towersystems/roam-common-native/lib/utilities/forms";
import { CategoryListScreenContext } from "../../../../../../components/CategoryListScreen/context";
import { FilterQuickKeyFormContext } from "../../context";
import { FilterEntity } from "../../types";
import { fetchAllFilters } from "./utils";
import { DepartmentListScreenContext } from "../../../../../../components/DepartmentListScreen/context";

export interface FilterQuickKeyFormProviderProps {
  children?: React.ReactNode;
}

export function FilterQuickKeyFormProvider({
  children,
}: FilterQuickKeyFormProviderProps) {
  const methods = useFormContext();
  const [entities, setEntities] = useState<FilterEntity[]>([]);

  const filter = useWatch<any>({
    control: methods.control,
    name: "filter",
  });

  function handleEntitySelect(entity: FilterEntity) {
    setEntities((prev) => {
      const newEntities = toggleListItem(prev, entity);

      methods.setValue(
        "filter.values",
        newEntities.map(({ id }) => id),
        { shouldDirty: true, shouldValidate: true }
      );

      return newEntities;
    });
  }

  function syncEntities() {
    if (!filter) {
      setEntities([]);
    } else {
      fetchAllFilters(filter)
        .then(setEntities)
        .catch(() => setEntities([]));
    }
  }

  useEffect(() => {
    syncEntities();
  }, [filter?.type]);

  let subContext = null;

  if (filter?.type === LayoutNodeFilterType.CATEGORY) {
    subContext = (
      <CategoryListScreenContext.Provider
        value={{
          selected: entities as Category[],
          onSelect: handleEntitySelect,
        }}
      >
        {children}
      </CategoryListScreenContext.Provider>
    );
  } else if (filter?.type === LayoutNodeFilterType.DEPARTMENT) {
    subContext = (
      <DepartmentListScreenContext.Provider
        value={{
          selected: entities as Department[],
          onSelect: handleEntitySelect,
        }}
      >
        {children}
      </DepartmentListScreenContext.Provider>
    );
  }

  return (
    <FilterQuickKeyFormContext.Provider
      value={{
        entities,
        setEntities,
        handleEntitySelect,
      }}
    >
      {subContext}
    </FilterQuickKeyFormContext.Provider>
  );
}
